import React from 'react';
import { connect } from 'react-redux';
import { Layer, Rect, Ellipse, Line, Stage, Group } from 'react-konva';
import styles from './styles.less';
import classnames from 'classnames';
import PropTypes from 'prop-types';

class SnapOverlay extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    return nextProps != this.props || nextState != this.state;
  }

  blendModeSupported() {
    return (
      typeof window.getComputedStyle(document.body).mixBlendMode !== 'undefined'
    );
  }

  render() {
    const {
      xPoint,
      yPoint,
      drawHorizontal,
      drawVertical,
      containerWidth,
      containerHeight,
      pageWidth,
      pageHeight,
      offSetX,
      offSetY,
    } = this.props;

    const strokeColor = this.blendModeSupported() ? 'white' : '#1eff26';
    const overlayClass = this.blendModeSupported()
      ? classnames(styles.snapOverlay, styles.invert)
      : styles.snapOverlay;

    const widthBase = Math.max(pageWidth, containerWidth);
    const heightBase = Math.max(pageHeight, containerHeight);
    let leftPageEdge = (widthBase - pageWidth) / 2 + 10;
    let topPageEdge = (heightBase - pageHeight) / 2 + 10;

    let horizontalPoints = [
      offSetY,
      topPageEdge + yPoint,
      widthBase + 20,
      topPageEdge + yPoint,
    ];
    let verticalPoints = [
      leftPageEdge + xPoint,
      offSetX,
      leftPageEdge + xPoint,
      heightBase + 20,
    ];

    return (
      <div className={overlayClass}>
        <Stage width={widthBase + 20} height={heightBase + 20}>
          <Layer>
            <Line
              points={horizontalPoints}
              stroke={strokeColor}
              strokeWidth={1}
              visible={drawHorizontal}
            />

            <Line
              points={verticalPoints}
              stroke={strokeColor}
              strokeWidth={1}
              visible={drawVertical}
            />
          </Layer>
        </Stage>
      </div>
    );
  }
}

SnapOverlay.propTypes = {
  containerWidth: PropTypes.number,
  containerHeight: PropTypes.number,
  pageWidth: PropTypes.number,
  pageHeight: PropTypes.number,
  drawHorizontal: PropTypes.bool,
  drawVertical: PropTypes.bool,
  xPoint: PropTypes.number,
  yPoint: PropTypes.number,
  offSetX: PropTypes.number,
  offSetY: PropTypes.number,
};

export default connect()(SnapOverlay);
